import { render } from "./TenantInitiated.vue?vue&type=template&id=7e7e1382"
import script from "./TenantInitiated.vue?vue&type=script&lang=js"
export * from "./TenantInitiated.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__